import { Component } from '@angular/core';
import { FaqConstants } from '../../app-core/constants/common-constants';

@Component({
	selector: 'app-faq-section',
	templateUrl: './faq-section.component.html',
	styleUrl: './faq-section.component.scss'
})
export class FaqSectionComponent {

	faqConstants: typeof FaqConstants = FaqConstants;
	searchTerm: string = '';

	faqs = [
		{
			question: 'How can I track my delivery or collection?',
			answer: `You can use our tracking facility on the day of your delivery or collection by <a href="https://www.arrowxl.co.uk" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to arrowxl.co.uk). Please make sure you have your postcode and tracking reference available.
      <br><br>
      If your order hasn’t been dispatched from your retailer, please contact them directly for more information.
      <br><br>
      Not found what you were looking for? You can speak to our live chat team by <a href="https://www.arrowxl.co.uk/help" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to Arrowxl.co.uk/help).`,
			open: false
		},
		{
			question: 'Where do I find my tracking reference?',
			answer: `You may have received your tracking reference from your retailer. The reference is usually 10 to 13 digits long and can be a mixture of numbers and letters.
      <br><br>
      If you did not receive a tracking reference from your retailer, get in contact with us using the options below. You will need to pass our security checks when you contact us.`,
			open: false
		},
		{
			question: 'I need to book my order back in for delivery or collection. How?',
			answer: `If you have a mobile number on your account, we will send you a SMS booking link and you can select a date.
      <br><br>
      If you have an email address on your account, we will email you a booking link and you can select a date.
      <br><br>
      If you have a landline number on your account, a member of the team will contact you to arrange a date.`,
			open: false
		},
		{
			question: 'When is my delivery or collection date?',
			answer: `You can check the date you’ve booked by
      <a href="https://ask.arrowxl.co.uk" target="_blank" rel="noopener noreferrer">clicking here</a> 
      (Redirects to AskAXL where they can enter UPI + Postcode to view tracking). 
	  <br><br>
      If your order hasn’t been dispatched from your retailer, please contact them directly for more information. 
	  <br><br>
      Not found what you were looking for? You can speak to our live chat team by
      <a href="https://www.arrowxl.co.uk/help" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to Arrowxl.co.uk/help).`,
			open: false
		},
		{
			question: 'When will I receive my booking confirmation?',
			answer: `You can see when your order has been booked by <a href="https://ask.arrowxl.co.uk" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to AskAXL where they can enter UPI + Postcode to view tracking) and entering your tracking reference and postcode.`,
			open: false
		},
		{
			question: 'Can I change the time slot that I’ve been allocated on the day?',
			answer: `We are unable to amend the time slot after it has been issued, however, we do have a few options available to help:
      <br><br>
      1) Can you ask somebody else to be in? They will need to be a responsible adult and have full access to the property.
      <br>
      2) Would another day be better for you? If you are happy to wait a little longer, you can select a day when you will be available.
      <br>
      3) Our delivery team will give you a call up to 30 minutes before they arrive at your property. Does this give you enough time to nip home if you aren’t far away?`,
			open: false
		},
		{
			question: 'Can I change the delivery address?',
			answer: `We are unable to change the address on your delivery. Please contact the retailer directly who will resolve this for you.`,
			open: false
		},
		{
			question: 'Can my delivery be given to a neighbour?',
			answer: `We are unable to deliver items to neighbours.`,
			open: false
		},
		{
			question: 'Can my delivery be left in a safe place?',
			answer: `We are unable to leave your delivery in a safe place. All deliveries require signatures.`,
			open: false
		},
		{
			question: 'I live in Ireland, the Channel Islands or the Scottish Islands. Where is my order?',
			answer: `Once your order has been shipped from the mainland, we will contact you to arrange a convenient delivery date. Please be aware this can take up to 10 working days.`,
			open: false
		},
		{
			question: 'Can I change my contact telephone number?',
			answer: `You can contact us to amend your contact number by <a href="https://www.arrowxl.co.uk/help" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to Arrowxl.co.uk/help). It is important we have the right contact details we will use this to send you your 2-hour delivery time slot. We will also call you 30 minutes before our crews arrive or if there are any changes to your planned delivery.`,
			open: false
		},
		{
			question: 'I’m having an item collected, how should I prepare it?',
			answer: `Washing Machine: Disconnect from the electrical supply and disconnect from the water supply, we cannot collect if the washing machine is still connected
      <br><br>
      Fridge / Freezer: Disconnect from the electrical supply, make sure the product is fully defrosted and ensure the item is free from perishables
      <br><br>
      Furniture: Ensure the product is appropriately packaged (Same way the item was delivered) furniture needs to be fastened together with no loose parts and please ensure that the items are safe to carry with no sharp edges protruding through the packaging
      <br><br>
      Beds: Ensure all bedding is removed from the bed
      <br><br>
      Sports Equipment: Disconnect the product from the electrical supply, dismantle the product and ensure the product is appropriately packaged (Same way the item was delivered)`,
			open: false
		},
		{
			question: 'I don’t need my delivery or collection anymore, what do I do?',
			answer: `If you have already accepted delivery of the order, please contact your retailer to arrange a return.
      <br><br>
      If your order hasn’t yet been delivered, you can cancel by contacting your retailer.
      <br><br>
      If your order is scheduled for delivery or collection today, please let us know we no longer need to attend your property. This will help us contribute to saving the planet!
      <br><br>
      You can contact us via webchat by <a href="https://www.arrowxl.co.uk/help" target="_blank" rel="noopener noreferrer">clicking here</a> (Redirects to Arrowxl.co.uk/help) or email customer.services@arrowxl.co.uk`,
			open: false
		},
		{
			question: 'I cannot find the answer to my question, so I need to speak to someone?',
			answer: `If you have any further questions or queries please follow this link <a href="https://api.whatsapp.com/send?phone=441942943700" target="_blank">https://api.whatsapp.com/send?phone=441942943700</a> and <a href="https://www.facebook.com/arrowxl" target="_blank">https://www.facebook.com/arrowxl</a>`,
			open: false
		}
	];

	get filteredFaqs() {
		if (!this.searchTerm.trim()) {
			return this.faqs;
		}
		return this.faqs.filter(faq =>
			faq.question.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
			faq.answer.toLowerCase().includes(this.searchTerm.toLowerCase())
		);
	}

	toggleFaq(selectedFaq: any) {
		this.faqs.forEach(faq => {
			faq.open = faq === selectedFaq ? !faq.open : false;
		});
	}
}
